module.exports = __webpack_public_path__ + "static/img/modal-error.bc7a6e88.png";